export default {
    baseUrl: 'https://admin.myanmarapn.com/api/',
    imageUrl: 'https://admin.myanmarapn.com',
}